module.exports = __webpack_public_path__ + "img/loader.8a7630ca.gif";